<template>
  <div id='app' class='app'>
    <router-view />
    <app-toaster />
    <app-cookie />
    <vue-up />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { subscribe, unsubscribe } from '@/api'
  import appToaster from '@/components/app-toaster'
  import appCookie from '@/components/app-cookie'

  export default {
    name: 'app',
    components: {
      appToaster,
      appCookie
    },
    metaInfo () {
      return {
        title: this.$t(`brandnames.${this.brandname}`),
        titleTemplate: '%s'
      }
    },
    computed: {
      ...mapState({
        brandname: 'brandname'
      }),
      ...mapState('error', {
        errorResponse: 'response'
      }),
      ...mapState('user', {
        authenticated: 'authenticated'
      })
    },
    created () {
      this.authChanged()
    },

    mounted () {
      if (this.$intercom) {
        this.$intercom.boot()
      }
      console.log(`${this.$t(`brandnames.${this.brandname}`)} started with version ${VERSION}`)
    },
    methods: {
      authChanged () {
        if (this.authenticated) {
          subscribe()
        } else {
          unsubscribe()
        }
      },

      ...mapActions('user', {
        setUnauthenticated: 'setUnauthenticated'
      })
    },
    watch: {
      authenticated () {
        this.authChanged()
      },

      errorResponse (response) {
        if (!response) return

        const { status } = response
        if (status === 401 && this.$route.name !== 'login') {
          this.setUnauthenticated()
          this.$router.push({
            name: this.$route.matched.some(route => route.meta.advisory === true) ? 'advisory-login' : 'login',
            query: {
              redirect: this.$route.fullPath
            }
          })
        } else if (Math.floor(status / 100) === 5) {
          this.$router.push({name: 'error500'})
        }
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/reset';
  @import '~@/styles/common';

  div.app > .app-toaster {
    padding-top: 8rem;
  }
</style>
